<template>
	<div>
		<notifications position="top center" group="info" />

		<h1 v-if="!minimal">Gestions d'éléments</h1>

		<b-form inline>
			<b-input-group v-if="!_type" prepend="Type">
				<b-form-select v-model="type" :options="types"></b-form-select>
			</b-input-group>
			<b-input-group prepend="Nom">
				<b-form-input v-model="name"></b-form-input>
			</b-input-group>
			<b-input-group prepend="Version">
				<b-form-input v-model="version"></b-form-input>
			</b-input-group>
			<b-form-checkbox
				v-model="env"
				v-show="user.env"
				class="ml-2 mr-2"
				switch
				>Env</b-form-checkbox
			>
			<b-button v-b-modal="'modal' + id">Charger</b-button>
			<b-button v-if="!minimal" @click="save_db" :disabled="!version || !name"
				><i class="fas fa-save"></i
			></b-button>
			<b-button v-if="!minimal" v-b-modal="'modal_file' + id">Fichier</b-button>
			<b-button v-if="!minimal" v-b-modal="'modal_rename' + id">Renommer</b-button>
			<b-button @click="new_elem"><i class="fas fa-plus"></i></b-button>
		</b-form>

		<b-modal :hide-footer="true" :id="'modal_file' + id" title="Fichier">
			<b-file
				accept=".json"
				@change="load_file"
				placeholder="charger (fichier)"></b-file>
			<br /><br />
			<b-button @click="save">sauvergarder (fichier)</b-button>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal_rename' + id" title="Renommer">
			<p>Nouveau nom</p>
			<b-input v-model="new_name"></b-input>
			<br />
			<b-button @click="rename">Rennomer</b-button>
		</b-modal>

		<b-modal :hide-footer="true" :id="'modal' + id" title="Charger">
			<span v-if="!_type">Type</span>
			<v-select v-if="!_type" v-model="type" :options="types"></v-select>
			<span>Nom</span>
			<v-select v-model="load_name" :options="names"></v-select>
			<span>Version</span>
			<v-select
				v-model="load_version"
				:options="versions"></v-select>
		</b-modal>

		<br />

		<div v-if="type == 'list'">
			<listWords
				@update_variant_show="updateListVariantShow"
				@update="updateList"
				ref="element"
				:id="'element' + id"
				extra=""></listWords>

			<div v-show="variant_show">
				<br />
				<b-button v-b-toggle="'collapse-' + id"
					>Appliquer à un ensemble de listes</b-button
				>

				<b-collapse :id="'collapse-' + id">
					<p>Appliquer aux listes (recherche sql avec like) :</p>
					<b-form-input v-model="search_lists_input"></b-form-input>
					<br />
					<b-button @click="search_lists">Rechercher</b-button>

					<div v-if="search_lists_result.length > 0">
						<p>Listes où seront appliqué les variants :</p>
						<ul>
							<li
								v-for="list in search_lists_result"
								:key="list.id">
								<span :style="'color:' + list.color">{{
									list.libelle
								}}</span>
							</li>
						</ul>
						<b-button @click="apply_variants">Appliquer</b-button>

						<listWords
							v-show="false"
							ref="element_tmp"
							:id="'element_tmp_' + id"
							extra=""></listWords>
					</div>
				</b-collapse>
			</div>

			<div v-if="create">
				<br />
				<b-button v-b-toggle="'collapse-add-' + id"
					>Multi listes</b-button
				>

				<b-collapse :id="'collapse-add-' + id">
					<br />
					<edit_tabulator
						:extern_file="true"
						ref="data_tabulator"
						@update="update_data"></edit_tabulator>
					<span>Colonne</span>
					<b-input v-model="column"></b-input>
					<span>Nom des listes</span>
					<b-input v-model="name"></b-input>
					<br />
					<b-button @click="buildList">Prévisualiser</b-button>

					<div v-for="(items, index) in lists" :key="index">
						<div>
							<b>{{ index }}</b
							><span
								v-if="
									!search_lists_result_libelle.includes(index)
								">
								- Nouvelle liste</span
							>
						</div>
						<span v-for="(word, index) in items" :key="word">
							{{ word }}
							<span v-if="index != items.length - 1"> - </span>
						</span>
					</div>

					<div v-if="search_lists_result.length > 0">
						<br /><br />
						<b-button @click="createList(false)"
							>Ajouter les valeurs ou créer les listes</b-button
						>&nbsp;&nbsp;
						<b-button @click="createList(true)"
							>Remplacer les listes ou les créer</b-button
						>
						<ul>
							<li
								v-for="list in search_lists_result"
								:key="list.id">
								<span :style="'color:' + list.color">{{
									list.libelle
								}}</span>
							</li>
						</ul>
					</div>
				</b-collapse>
			</div>
		</div>
		<div v-if="type == 'document_type'">
			<document_template_type
				ref="element"
				start_name="type"></document_template_type>
		</div>
		<div v-if="type == 'document_zone'">
			<document_extraction
				ref="element"
				start_name="type"
				:composant="true"></document_extraction>
		</div>
		<div v-if="type === 'service'">
			<service_type ref="element" start_name="type"></service_type>
		</div>
		<div v-if="type === 'appel_service'">
			<appel_service_type
				ref="element"
				start_name="type"></appel_service_type>
		</div>
		<div v-if="type == 'code'">
			<execution_code :library="true" ref="element" :name="name" :version="version"></execution_code>
		</div>
	</div>
</template>

<script>
	import uniqueId from "lodash.uniqueid";
	import template from "lodash.template";

	import store from "../store";
	import utils from "../services/utils.js";
	import element from "../services/element.js";
	import execution_code from '../views/Code.vue';
	import listWords from "../components/listWords.vue";
	import service_type from "../components/service_type.vue";
	import document_extraction from "./DocumentExtraction.vue";
	import edit_tabulator from "../components/edit_tabulator.vue";
	import appel_service_type from "../components/appel_service_type.vue";
	import document_template_type from "../components/document_template_type.vue";

	export default {
		name: "elem",
		components: {
			listWords,
			edit_tabulator,
			document_template_type,
			document_extraction,
			service_type,
			appel_service_type,
			execution_code
		},
		props: {
			_type: {
				default: null
			},
			minimal: {
				default: false
			}
		},
		data() {
			return {
				types: [
					{ value: "list", text: "liste" },
					{ value: "document_type", text: "Document - types" },
					{ value: "document_zone", text: "Document - zones" },
					{ value: "service", text: "Service" },
					{ value: "appel_service", text: "Appel à un service" }
				],
				names: [],
				versions: [],
				type: "",
				name: "",
				new_name: name,
				version: "",
				id: uniqueId(),
				load_name: "",
				load_version: "",
				search_lists_input: "",
				search_lists_result: [],
				search_lists_result_libelle: [],
				variant_show: false,
				column: "",
				name: "",
				tabulator_data: [],
				lists: {},
				search: "",
				create: true,
				env: false,
				user: {},
			};
		},
		computed: {
			names_filters() {
				if (!this.search) return this.names;
				else
					return this.names.filter((item) =>
						item
							? item
									.toLowerCase()
									.indexOf(this.search.toLowerCase()) != -1
							: 0
					);
			},
		},
		watch: {
			type: {
				async handler() {
					this.set_name();
				},
			},
			load_name: {
				async handler() {
					var elements = await element.getby_libelle(
						this.load_name,
						this.type
					);
					elements = elements.element;

					this.versions = [];
					for (var i = 0; i < elements.length; i++) {
						if (i == 0) {
							if (
								this.load_version &&
								this.load_version == elements[i].version
							)
								await this.load_db();
							this.load_version = elements[i].version;
						}
						this.versions.push(elements[i].version);
					}
				},
			},
			load_version: {
				async handler() {
					if (this.load_version) await this.load_db();
				},
			},
		},
		methods: {
            isAdmin: function() {
                return store.getters.isUserAdmin;
            },
			async rename() {
				await element.rename(this.type, this.name, this.new_name);
				this.name = this.new_name;
				await this.set_name();
			},
			async new_elem() {
				this.name = "";
				this.version = "";
				this.$refs.element.new();
			},
			async set_name() {
				var names = await element.getby_production(this.type, null, false);
				names = names.element;

				this.names = [];
				for (var i = 0; i < names.length; i++) {
					this.names.push(names[i].libelle);
				}
			},
			async load_file(event) {
				var self = this;

				var file = "";
				if (event.dataTransfer) file = event.dataTransfer.files[0];
				else file = event.target.files[0];

				var reader = new FileReader();

				reader.onload = (function (theFile) {
					return async function (e) {
						var data = JSON.parse(e.target.result);
						document.body.style.cursor = "wait";
						await self.$refs.element.load(data);
						document.body.style.cursor = "default";
					};
				})(file);

				reader.readAsText(file);
			},
			async load_db() {
				document.body.style.cursor = "wait";
				var result = await element.load(
					this.load_name,
					this.load_version,
					this.type
				);
				this.name = this.load_name;
				this.version = this.load_version;
				await this.$refs.element.load(result);
				this.env = false;
				console.log(result);
				if (result.env && result.env == this.user.env) this.env = true;
				document.body.style.cursor = "default";
			},
			async save() {
				var data = await this.$refs.element.save();

				utils.saveToFile(
					JSON.stringify(data),
					(this.name ? this.name : this.type) + ".json"
				);
			},
			async save_db() {
				var data = await this.$refs.element.save(false);
				if (this.env) data.env = this.user.env;

				await element.save(
					this.name,
					this.version,
					data,
					this.type,
					this.env,
					data.data_db === undefined ? {} : data.data_db
				);
				await this.set_name();

				this.$notify({
					group: "info",
					title: "Enrgistrement en base effectué",
					type: "success",
				});
			},
			updateList(id, name, list, parameters) {
				if (name) this.name = name;

				if (list.length == 0) this.create = true;
				else this.create = false;
			},
			updateListVariantShow(variant_show) {
				this.variant_show = variant_show;
			},
			async search_lists() {
				var lists = await element.getby_production(
					"list",
					this.search_lists_input || null,
					false
				);
				this.search_lists_result = lists.element;
			},
			async apply_variants() {
				var variants = await this.$refs.element.getVariants();

				for (var i = 0; i < this.search_lists_result.length; i++) {
					try {
						this.search_lists_result[i].color = "orange";
						var result = await element.load(
							this.search_lists_result[i].libelle,
							this.search_lists_result[i].version,
							"list"
						);
						await this.$refs.element_tmp.load(result);
						this.$refs.element_tmp.setVariants(variants);
						this.$refs.element_tmp.set_variant_list();
						var data = await this.$refs.element_tmp.save();
						await element.save(
							this.search_lists_result[i].libelle,
							this.search_lists_result[i].version + "_v",
							data,
							"list"
						);
						this.search_lists_result[i].color = "green";
					} catch (err) {
						this.search_lists_result[i].color = "red";
					}
					this.$set(
						this.search_lists_result,
						i,
						this.search_lists_result[i]
					);
				}
				var result = await element.load(
					this.name,
					this.version + "_v",
					"list"
				);
				await this.$refs.element.load(result);
				await this.set_name();
			},
			update_data(id, data) {
				this.tabulator_data = data;
			},
			buildList: async function () {
				var lists = {};
				var template_colonne = template(this.name);
				var template_value = template(this.column);

				await this.search_lists();

				this.search_lists_result_libelle = [];
				for (var i = 0; i < this.search_lists_result.length; i++) {
					this.search_lists_result_libelle.push(
						this.search_lists_result[i].libelle
					);
				}

				for (var i = 0; i < this.tabulator_data.length; i++) {
					var name = template_colonne({
						data: this.tabulator_data[i],
					});
					if (!lists[name]) {
						lists[name] = [];
						if (!this.search_lists_result_libelle.includes(name))
							this.search_lists_result.push({
								libelle: name,
								version: "1",
								new: true,
							});
					}
					var value = "";
					if (this.column.indexOf("$") == -1)
						value = this.tabulator_data[i][this.column];
					else
						value = template_value({
							data: this.tabulator_data[i],
						});
					if (!lists[name].includes(value) && value) {
						lists[name].push(value);
					}
				}

				var _tmp_list = [];
				for (var i = 0; i < this.search_lists_result.length; i++) {
					if (lists[this.search_lists_result[i].libelle])
						_tmp_list.push(this.search_lists_result[i]);
				}

				this.lists = lists;
				this.search_lists_result = _tmp_list;
			},
			createList: async function (replace = false) {
				for (var i = 0; i < this.search_lists_result.length; i++) {
					try {
						if (
							this.lists[this.search_lists_result[i].libelle]
								.length > 0
						) {
							this.search_lists_result[i].color = "orange";
							if (!this.search_lists_result[i].new) {
								var result = await element.load(
									this.search_lists_result[i].libelle,
									this.search_lists_result[i].version,
									"list"
								);
								await this.$refs.element_tmp.load(result);
								this.search_lists_result[i].version =
									this.search_lists_result[i].version + "_v";
							} else {
								await this.$refs.element_tmp.load({
									name: this.search_lists_result[i].libelle,
									list: [],
									parameters: {
										variant_parameters: {},
									},
								});
							}
							await this.$refs.element_tmp.addValues(
								this.lists[this.search_lists_result[i].libelle],
								replace
							);
							var data = await this.$refs.element_tmp.save();
							await element.save(
								this.search_lists_result[i].libelle,
								this.search_lists_result[i].version,
								data,
								"list"
							);
							this.search_lists_result[i].color = "green";
						}
					} catch (err) {
						console.log(err);
						this.search_lists_result[i].color = "red";
					}
					this.$set(
						this.search_lists_result,
						i,
						this.search_lists_result[i]
					);
					await this.set_name();
					this.$notify({
						group: "info",
						title: "Modifications et ajouts des listes effectuées",
						type: "success",
					});
				}
			},
		},
		mounted: async function () {
			this.user = store.state.user;
			if (store.state.user.rules && !store.state.user.rules.elements && !this._type) {
				this.$router.push({ name: "profile" });
			}

			this.type = this._type || "list";

			if (this.isAdmin())
				this.types.push({ value: "code", text: "Code" });
		},
	};
</script>
